export enum CopayPaStatus {
  Approved = 'Approved',
  InProgress = 'In Progress',
  Denied = 'Denied',
  Cancelled = 'Cancelled',
}
